import styled from 'styled-components';

export default function PaymentOptionCustomInput(props) {
  const { value, setValue, placeholder, width, disabled, index } = props;

  // 입력값 변경 처리 //
  function onChangeInput(e) {
    const inputValue = e.target.value;

    if (inputValue === '' || /^[0-9][0-9,]*$/.test(inputValue)) {
      setValue(inputValue, index);
    }
  }

  // 포커스 시 0값 초기화 //
  function onFocusInput(e) {
    if (value === '0') setValue('', index);
  }

  return (
    <InputWrapper width={width} disabled={disabled}>
      <Input
        type='text'
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onChange={onChangeInput}
        onFocus={onFocusInput} />
    </InputWrapper>
  )
}

const InputWrapper = styled.div`
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
  gap: 5px;

  width: ${props => props.width ? `${props.width}px` : '100%'};
  height: 50px;

  background: ${props => props.disabled ? '#ECECEC' : '#FFFFFF'};
  border: 1px solid #D4D4D4;
  border-radius: 10px;

  flex-grow: 1;

  &:focus-within {
    border-color: #FF8B48;
  }

  transition: border-color 0.3s ease-in-out;
`;

const Input = styled.input`
  width: 100%;
  height: 21px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 17px;

  text-align: right;

  color: ${props => props.disabled ? '#FFFFFF' : '#232323'};
  background: transparent;

  border: none;
  outline: none;
  padding: 0;

  cursor: ${props => props.disabled ? 'not-allowed' : 'text'};

  ::placeholder {
    color: #CBCBCB;
  }
`;
